const Product = [
    {
      id: '31',
      department:"New Arrival",
      name: 'Vel elit euismod',
      code:"Code - Y523201",
      image:'/image/ch19.png',
        price:"$42.00" ,
    oldprice:"$65.00"
          },
   {
      id: '32',
      department:"New Arrival",
      name: 'Vitae suspendisse sed',
      code:"Code - Y523201",
      image:'/image/ch21.png',
        price:"$42.00" ,
    oldprice:"$65.00"
         },
    {
      id: '33',
      department:"New Arrival",
      name: 'Ultricies condimentum imperdiet',
      code:"Code - Y523201",
      image:'/image/ch20.png',
        price:"$42.00" ,
    oldprice:"$65.00"
                      },
    {
      id: '34',
      department:"New Arrival",
      name: 'Fusce pellentesque at',
      code:"Code - Y523201",
      image:'/image/watch1.png',
        price:"$42.00" ,
    oldprice:"$65.00"
      },
      {
        id: '35',
        department:"New Arrival",
        name: 'Vestibulum magna laoreet',
        code:"Code - Y523201",
        image:'/image/watch2.png',
          price:"$42.00" ,
      oldprice:"$65.00"
       
        },

        {
          id: '36',
          department:"New Arrival",
          name: 'Sollicitudin amet orci',
          code:"Code - Y523201",
          image:'/image/music.png',
            price:"$42.00" ,
        oldprice:"$65.00"
         
          },
          {
            id: '37',
            department:"Best Seller",
            name: 'Ultrices mauris sit',
            code:"Code - Y523201",
            image:'/image/ch22.png',
              price:"$42.00" ,
          oldprice:"$65.00"
           
            },
            {
              id: '390',
              department:"Featured",
              name: 'Cantilever chair',
              code:"Code - Y523201",
              image:'/image/ch11.png',
                price:"$42.00" ,
            oldprice:"$65.00"
             
              },
            {
              id: '38',
              department:"Best Seller",
              name: 'Pellentesque condimentum ac',
              code:"Code - Y523201",
              image:'/image/watch3.png',
                price:"$42.00" ,
            oldprice:"$65.00"
             
              },

              {
                id: '39',
                department:"Best Seller",
                name: 'Cras scelerisque velit',
                code:"Code - Y523201",
                image:'/image/cam1.png',
                  price:"$42.00" ,
              oldprice:"$65.00"
                },

                {
                  id: '40',
                  department:"Featured",
                  name: 'Lectus vulputate faucibus',
                  code:"Code - Y523201",
                  image:'/image/hand2.png',
                    price:"$42.00" ,
                oldprice:"$65.00"
                 
                  },
 {
      id: '41',
      department:"Featured",
      name: 'Cantilever chair',
      code:"Code - Y523201",
      image:'/image/ch11.png',
        price:"$42.00" ,
    oldprice:"$65.00"
     
      },
     

  ];
  
  export default Product;